
import axiosClient from "./axiosClient";

const serviceUrl = 'qlkhambenh';

const listExamination = {
    getListPatients: async (params) => {
      const url = serviceUrl + `/phieu-kham/list-phieu-kham-theo-phong`;
      const response = await axiosClient.get(url, {params});
      return response;;
    },
    updateStatusPK: async (params) => {
      const url = serviceUrl + `/phieu-kham/cap-nhat-trang-thai?id=${params.id}&trangThai=${params.trangThai}`;
      const response = await axiosClient.put(url);
      return response;;
    },
    getListDMBoChiDinh: async (params) => {
      const url = serviceUrl + `/dm-bo-chi-dinh/list-dm-bo-chi-dinh`;
      const response = await axiosClient.get(url);
      return response;
    },
    getDMNhomDichVu: async (params) => {
      const url = serviceUrl + `/dm-nhom-dich-vu/tree-dm-nhom-dich-vu`;
      const response = await axiosClient.get(url);
      return response;
    },
    getListDMDichVuKham: async (params) => {
      const url = serviceUrl + `/dm-dich-vu/list-dm-dich-vu-kham`;
      const response = await axiosClient.get(url);
      return response;
    },
    getByIdNDV: async (params) => {
      const url = serviceUrl + `/dm-dich-vu/get-by-id-nhom-dich-vu`;
      const response = await axiosClient.get(url, {params: params});
        return response;
    },
    postBCD: async (params) => {
      const url = serviceUrl + `/dm-bo-chi-dinh`;
      const response = await axiosClient.post(url, params);
      return response;
    },
    deleteBCD: async (params) => {
      const url = serviceUrl + `/dm-bo-chi-dinh`;
      const response = await axiosClient.delete(url, {
        params: params
      });
      return response;
    }
};

export default listExamination;
